import { __assign } from "tslib";
import baseTheme from './baseTheme';
export var glow = function (otherStyles, whenFocusVisible) {
    var _a, _b;
    return (__assign(__assign(__assign(__assign({}, otherStyles), { transition: [
            otherStyles.transition || '',
            baseTheme.transitions.create('box-shadow', {
                duration: '0.2s',
            }),
        ]
            .filter(Boolean)
            .join(', '), '&:focus': __assign(__assign({}, (otherStyles['&:focus'] || {})), { boxShadow: "0 0 0 5px " + baseTheme.palette.primary.light, zIndex: 10, transition: [
                (_a = otherStyles['&:focus']) === null || _a === void 0 ? void 0 : _a.transition,
                baseTheme.transitions.create('box-shadow', {
                    duration: '0.2s',
                }),
            ]
                .filter(Boolean)
                .join(', ') }), '&:focus-within': __assign(__assign({}, (otherStyles['&:focus-within'] || {})), { boxShadow: "0 0 0 5px " + baseTheme.palette.primary.light, zIndex: 10, transition: [
                (_b = otherStyles['&:focus-within']) === null || _b === void 0 ? void 0 : _b.transition,
                baseTheme.transitions.create('box-shadow', {
                    duration: '0.2s',
                }),
            ]
                .filter(Boolean)
                .join(', ') }) }), (whenFocusVisible
        ? {
            '&:focus-visible, &$focusVisible, &.Mui-focusVisible': __assign(__assign({}, (otherStyles['&$focusVisible'] || {})), { boxShadow: "0 0 0 5px " + baseTheme.palette.primary.light, zIndex: 10, transition: [
                    otherStyles['&$focusVisible'] &&
                        otherStyles['&$focusVisible'].transition,
                    baseTheme.transitions.create('box-shadow', {
                        duration: '0.2s',
                    }),
                ]
                    .filter(Boolean)
                    .join(', ') }),
        }
        : {})), { '&:hover': __assign(__assign({}, (otherStyles['&:hover'] || {})), { boxShadow: "0 0 0 5px " + baseTheme.palette.primary.light, zIndex: 10, transition: [
                otherStyles['&:focus'] &&
                    otherStyles['&:focus'].transition,
                baseTheme.transitions.create('box-shadow', {
                    duration: '0.2s',
                }),
            ]
                .filter(Boolean)
                .join(', ') }) }));
};
//# sourceMappingURL=effects.js.map